import type { IconDefinition } from '../index.tsx';

export const iconFilter: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconFilter',
  icon: [16, 16, [], '', 'M1 1H15V4L10 10V16H6V10L1 4V1Z'],
};
